import { API_V1 } from '../api';

export function getGroupCategories(groupId: string): Promise<string[]> {
	return API_V1.get(`/groups/${groupId}/categories`)
		.then(({ data }) => data as string[]);
}

export function deleteGroupCategory(groupId: string, category: string): Promise<string[]> {
	return API_V1.delete(`/groups/${groupId}/categories`, { params: { category } })
		.then(({ data }) => data as string[]);
}

export interface AddCategoryRequest {
	category: string;
}

export function addGroupCategory(groupId: string, category: string): Promise<string[]> {
	const payload: AddCategoryRequest = { category };
	return API_V1.put(`/groups/${groupId}/categories`, payload)
		.then(({ data }) => data as string[]);
}

export interface RenameCategoryRequest {
	existingCategory: string;
	newCategoryName: string;
}

export function renameGroupCategory(groupId: string, existingCategory: string, newCategoryName: string): Promise<string[]> {
	const payload: RenameCategoryRequest = { existingCategory, newCategoryName };
	return API_V1.post(`/groups/${groupId}/categories`, payload)
		.then(({ data }) => data as string[]);
}
